import store from '@/plugins/store'
import { AxiosClient } from '@/app/common/services/http/axios-client.service'
import { GetMyUploadedDocumentsCommand } from '@/app/my-uploaded-documents/commands/get-my-uploaded-documents.command'
import { ViewMyUploadedDocumentCommand } from '@/app/my-uploaded-documents/commands/view-my-uploaded-document.command'
import { DeleteMyUploadedDocumentCommand } from '@/app/my-uploaded-documents/commands/delete-my-uploaded-document.command'

const httpClient = new AxiosClient()

export const getMyDocumentsCommand = new GetMyUploadedDocumentsCommand(httpClient, store)
export const viewMyUploadedDocumentCommand = new ViewMyUploadedDocumentCommand(httpClient, store)
export const deleteMyUploadedDocumentCommand = new DeleteMyUploadedDocumentCommand(httpClient, store)


